import React, { useState } from "react";
import { ErrorMessage, Formik } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import clsx from "clsx";
import { generateSignedUrl } from "../../../models/_worOrder";
import { FOLDER_NAME } from "../../../../_metronic/helpers/enums";
import Breadcrumb from "../../Common/Breadcrumb";
import { createLedRings } from "../../../models/_ledRings";

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
  mediaFile: yup.mixed()
  .nullable()
  .test("fileType", "Only image files are supported", (value) =>
    value ? ["image/jpeg", "image/png", "image/gif"].includes(value.type) : true
  ),
});

export const handleMediaFileUpload = async (
  mediaFile: any,
  folderName: string
): Promise<{mediaUrl: string}> => {
  const result = {mediaUrl: ""};
  try {
    const response = await generateSignedUrl({
      file_name: mediaFile.name,
      file_type: mediaFile.type,
      folder_name: folderName,
    });
    const mediaUrl = response?.data?.data?.generateSignedUrl?.url;

    const uploadedMediaFile = await fetch(mediaUrl, {
      method: "PUT",
      headers: {
        "Content-Type": mediaFile.type,
      },
      body: mediaFile,
    });

    if(uploadedMediaFile.ok){
      return mediaUrl.split("?")[0];
    }
    return result;
  } catch (error) {
    console.error("Error while handleFileUpload:", error);
    return result;
  }
}

function CreateLedRings() {
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
          style={{ maxWidth: "100%" }}
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap">
            <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
              Create Led Rings
            </h1>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0">
            <Breadcrumb
              links={[
                { label: "Home", href: "/dashboard", isActive: false },
                { label: "Create Led Rings", href: "", isActive: true },
              ]}
            />
          </div>
        </div>
      </div>

      <div className="card mx-xl-4 mt-9">
        <Formik
          initialValues={{
            name: "",
            description: "",
            mediaFile: null,
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm, setSubmitting }) => {            
            setLoading(true);
            let $inputData: any = {
              name: values.name,
              description: values.description,
            };

            if(values.mediaFile) {
             const url = await handleMediaFileUpload(values.mediaFile,FOLDER_NAME.LED_RINGS_IMAGES);
             $inputData.mediaUrl = url;
            }
            
            const result = await createLedRings($inputData);
            if (result?.data?.data?.createLedRings) {
              toast.success("Led Rings successfully");
              setSubmitting(false);
              setLoading(false);
              resetForm();
            } else {
              setSubmitting(false);
              setLoading(false);
              const messages = result?.data?.errors.map((e: any) => e.message);
              toast.error(messages.join(","));
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
            setFieldValue,
          }) => (
            <div className="card-body w-100 p-lg-7 p-md-7 p-5">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4 required fw-bold">
                      Name
                    </label>
                    <input
                      className={clsx("form-control", {
                        "is-invalid": Boolean(errors.name) && touched.name,
                      })}
                      name="name"
                      id="name"
                      value={values.name}
                      onChange={handleChange}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="name" />
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4  fw-bold">
                      Description
                    </label>
                    <textarea
                      className={clsx("form-control", {
                        "is-invalid": Boolean(errors.description) && touched.description,
                      })}
                      name="description"
                      id="description"
                      value={values.description}
                      onChange={handleChange}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="description" />
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                     <label className="form-label fs-4 fw-bold">
                      Media File
                    </label>
                    <div className="d-flex">
                      <label htmlFor="mediaFile" className="fs-4">
                        <input
                          type="file"
                          id="mediaFile"
                          accept="image/*"
                          placeholder="Upload media file"
                          className="d-none"
                          onChange={(event) => {
                            const file = event.currentTarget.files ? event.currentTarget.files[0] : null;
                            setFieldValue("mediaFile", file);
                          }}
                        />
                        <span
                          className="btn btn-bg-light text-gray-700 fs-4 w-100 mt-2 ms-2 fs-5 px-5 py-3 w-100"
                          style={{ cursor: "pointer" }}
                        >
                          Upload Media File
                        </span>
                      </label>
                    </div>
                      <div className="text-danger text-align-top-center mt-2">
                        <ErrorMessage name="mediaFile" />
                      </div>
                  </div>
                 </div>

                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 px-xl-5 p-2">
                    <button
                      type="submit"
                      className="btn btn-primary me-4 fs-4 w-100"
                    >
                      {loading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Please Wait..
                          <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                        </span>
                      )}
                      {!loading && (
                        <span className="indicator-label">ADD Led Rings</span>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </Formik>

        <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
      </div>
    </div>
  );
}

export default CreateLedRings;
